<div *ngIf="projectNotes$ | async as projectNotes">
    <table id="projectNotesContainer" class="table table-striped table-condensed">
        <thead>
            <tr>
                <td style="width:75px;">Note Date</td>
                <td style="width:10px;"> </td>
                <td>Note</td>
                <td style="width:130px;"></td>
                <td style="width:5px;"></td>
            </tr>
        </thead>
        <tbody style="padding-right:20px">
    
            <!-- noteItem is a directive that stamps out note rows formatted  
                 correctly according to the type of note -->
                  <!-- [ngClass]="isVisible(projectNote.noteTypes) ? 'visible' : 'hidden'" -->
            <ng-container *ngFor="let projectNote of projectNotes">
                <tr *ngIf="!isMemberNote(projectNote) && !isAnalystOpinion(projectNote)"    
                    eic-normal-project-note 
                    [projectNote]="projectNote">
                </tr>
                <tr *ngIf="!isMemberNote(projectNote) && isAnalystOpinion(projectNote)" 
                    eic-analyst-project-note
                    [projectNote]="projectNote">
                </tr>
                <tr *ngIf="isMemberNote(projectNote)" 
                    eic-member-project-note 
                    [projectNote]="projectNote"
                    [showMemberNoteControls]="showMemberNoteControls">
                </tr>
            </ng-container>
    
        </tbody>
    </table>
</div>
